"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const polished_1 = require("polished");
const react_1 = tslib_1.__importDefault(require("react"));
const styled_components_1 = tslib_1.__importDefault(require("../Themes/styled-components"));
const Action_1 = tslib_1.__importDefault(require("./Action"));
const Header_1 = tslib_1.__importDefault(require("./Header"));
const Item_1 = tslib_1.__importDefault(require("./Item"));
const Spacer_1 = tslib_1.__importDefault(require("./Spacer"));
const Wrapper = styled_components_1.default.div `
  height: ${({ theme }) => polished_1.rem(theme.headerBar.height)};
  background-color: ${({ theme }) => theme.headerBar.backgroundColor};
  padding: ${polished_1.rem(8)} ${polished_1.rem(8)};
  display: flex;
  align-items: center;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
  color: ${({ theme }) => theme.textColor};
  position: relative;
  z-index: 1;
`;
const HeaderBar = ({ children }) => {
    return react_1.default.createElement(Wrapper, null, children);
};
HeaderBar.Spacer = Spacer_1.default;
HeaderBar.Item = Item_1.default;
HeaderBar.Header = Header_1.default;
HeaderBar.Action = Action_1.default;
exports.default = HeaderBar;
